import { render, staticRenderFns } from "./lolth-file-item.vue?vue&type=template&id=0bc72834&scoped=true&"
import script from "./lolth-file-item.vue?vue&type=script&lang=ts&"
export * from "./lolth-file-item.vue?vue&type=script&lang=ts&"
import style0 from "./lolth-file-item.vue?vue&type=style&index=0&id=0bc72834&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc72834",
  null
  
)

/* custom blocks */
import block0 from "./lolth-file-item.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports